import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    user_id: null, //IdRef, optional // Mã người dùng được cấp huy hiệu
    huy_hieu_id: null, //IdRef, optional
    dang_ky_chuong_trinh_id: null, //IdRef, optional
    thoi_diem_tao: null, //datetime, optional // Thời điểm nhận được huy hiệu
    ghi_chu: null, //string, optional // Ghi chú
    nguoi_cap_id: null, //IdRef, optional // Mã cấp huy hiệu   
    // da_duyet: null, //boolean, optional // Đã duyệt hay chưa
};

// validation form
model.validForm = {
    user_id: [ValidService.required], //IdRef, optional // Mã người dùng được cấp huy hiệu
    huy_hieu_id: [ValidService.required], //IdRef, optional
    dang_ky_chuong_trinh_id: [ValidService.required], //IdRef, optional
    thoi_diem_tao: [], //datetime, optional // Thời điểm nhận được huy hiệu
    ghi_chu: [], //string, optional // Ghi chú
    nguoi_cap_id: [], //IdRef, optional // Mã cấp huy hiệu   
    // da_duyet: [], //boolean, optional // Đã duyệt hay chưa

};

// dữ liệu mẫu các form khác
model.dataFormOther = {};

// validation các form khác
model.validFormOther = {};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["thoi_diem_tao", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {

            user_id: "",
            huy_hieu_id: "",
            thoi_diem_tao: ""
        },
        valid: {
            user_id: [],
            huy_hieu_id: [],
            thoi_diem_tao: ""
        },
        operator: {
            // ma: ":regex:",
            // 'ten.vi': ":regex_i:", //:regex:, $vn_text=Viêt nam
            // 'ten.en': ":regex_i:"
            thoi_diem_tao: ":in_that_day:"
        }
    }
};

export default model;